// extracted by mini-css-extract-plugin
export var intro = "index-module--intro--2Oy3K";
export var entryContent = "index-module--entryContent--3QSX3";